import CodeDocumentType from "./code_document_type.js";
import Document from "./document.js";
import DocumentVersion from "./document_version.js";
import DocumentCategory from "./document_category.js";
import DocumentHistory from "./document_history.js";
import DocumentRead from "./document_read.js";

export default {
  CodeDocumentType,
  Document,
  DocumentVersion,
  DocumentCategory,
  DocumentHistory,
  DocumentRead,
};
